// extracted by mini-css-extract-plugin
export default {"container":"jNNr","modalWrapper":"eV2Y","popupAppearance":"ypFl","closeBtn":"Ee5G","outerCloseBtn":"YH1F","innerCloseBtn":"Zy2N"};